import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  PhoneFilters,
  WithOptionsFilterFilters,
} from '@/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const customersFilters: () => (
  | PhoneFilters
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '가입 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'signupSourceLike',
    label: '가입 경로',
    placeholder: '가입 경로를 입력해주세요',
  },
  {
    key: 'status',
    label: '회원 상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '일반 회원', value: 'normal' },
      { label: '탈퇴 회원', value: 'withdrawal' },
      { label: '정지 회원', value: 'suspended' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'nickLike',
    label: '닉네임',
    placeholder: '닉네임을 입력해주세요',
  },
  {
    key: 'name',
    label: '회원 이름',
    placeholder: '이름을 입력해주세요',
  },
  {
    key: 'phone',
    label: '핸드폰 번호',
    placeholder: "핸드폰 번호를 입력해주세요 ('-' 제외)",
    type: ListFilterTypeObject.PHONE,
  },
  {
    key: 'isMarketingAgreed',
    label: '마케팅 활용 동의 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.agreed, value: 'true' },
      { label: OPTIONS_CONST.notAgreed, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
];
